export * from './vscroll';

export interface IResizeInfo {
  readonly height: number;
  readonly width: number;
}
